module.exports = __webpack_public_path__ + "static/media/rise.984f041c.svg";